<!--
@Time : 2020/11/29 7:35 下午
@Author : yekong
@File : haoshi2.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="het">
      <div class="item1">耗时统计（小时/年）</div>
      <div class="item2">大连</div>
      <div class="item2">上海</div>
      <div class="item2">北京</div>
      <div class="item2">深圳</div>
    </div>
    <div class="bod">
      <div class="itemb">
        <div class="item1">会计账簿取数收集资料</div>
        <div class="item2">9</div>
        <div class="item2">6</div>
        <div class="item2">10</div>
        <div class="item2">10</div>
      </div>
      <div class="itemb">
        <div class="item1">账簿分析及计算应纳税额</div>
        <div class="item2">17.5</div>
        <div class="item2">10</div>
        <div class="item2">16.5</div>
        <div class="item2">15</div>
      </div>
      <div class="itemb">
        <div class="item1">更新快捷账簿及学习新税法</div>
        <div class="item2">19.5</div>
        <div class="item2">21.5</div>
        <div class="item2">1.56</div>
        <div class="item2">15</div>
      </div>
      <div class="itemb">
        <div class="item1">填写申报表</div>
        <div class="item2">8</div>
        <div class="item2">9</div>
        <div class="item2">10</div>
        <div class="item2">10</div>
      </div>
      <div class="itemb">
        <div class="item1">提交申报表</div>
        <div class="item2">2.5</div>
        <div class="item2">2</div>
        <div class="item2">1.5</div>
        <div class="item2">2.5</div>
      </div>
      <div class="itemb">
        <div class="item1">实体服务厅或网上集银行纳税</div>
        <div class="item2">1.5</div>
        <div class="item2">2</div>
        <div class="item2">1.5</div>
        <div class="item2">3</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "haoshi2",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.het {
  width: 944px;
  height: 48px;
  background: #404C6E;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 22px;
  font-family: PingFang;
  font-weight: 800;
  color: #FFFFFF;
  margin-top: 30px;

  .item1 {
    width: 50%;
    text-indent: 13px;
  }

  .item2 {
    width: 16%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
}
.itemb{
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  border-bottom: 2px solid rgba(129, 134, 155, 1);

  .item1 {
    width: 50%;
    text-indent: 13px;
  }

  .item2 {
    width: 16%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
}
</style>
